// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @commons
const OKModal = require('components/commons/OKModal/OKModal');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @actions
const BrokerMiFIDUSPersonActions = require('mifid/actions/brokerMiFIDUSPerson');

class BrokerMIFIDUSPersonModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = { continueCalled: false, fetched: false };

        this.handleCancel = this.handleCancel.bind(this);
        this.handleContinue = this.handleContinue.bind(this);
        this.fetchInfo = this.fetchInfo.bind(this);

    }

    UNSAFE_componentWillMount() {
        this.fetchInfo(this.props);
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        this.fetchInfo(newProps);
        if (newProps.immBrokerMiFIDUSPerson.get('canContinueOperation')) {
            this.handleContinue();
        }
    }

    componentWillUnmount() {
        this.props.onReset();
    }

    fetchInfo(props) {
        const {
            marketId,
            isinId,
            feeNumbers,
            eventCode,
            valueCode,
            operationType,
            history
        } = props;
        if (!this.state.fetched && isinId) {
            props.onFetchInfo(
                isinId,
                marketId,
                { feeNumbers, eventCode, valueCode, operationType },
                history
            );
            this.setState({ fetched: true });
        }
    }

    handleCancel() {
        this.props.onReset();
        this.props.onCancel();
    }

    handleContinue() {
        if (!this.state.continueCalled) {
            const { history, onBeforeContinueOperation, onContinueOperation } = this.props;

            this.setState({ continueCalled: true });
            onBeforeContinueOperation(history, onContinueOperation);
        }
    }

    render() {
        const { immBrokerMiFIDUSPerson, displayWhileLoading } = this.props;

        const isFetching = immBrokerMiFIDUSPerson.get('isFetching');
        const displayDisclaimer = immBrokerMiFIDUSPerson.get('displayDisclaimerModal');

        const buildDescription = <div dangerouslySetInnerHTML={{ __html: immBrokerMiFIDUSPerson.getIn(['disclaimers', 0, 'description']) }} />
        if (isFetching && displayWhileLoading) {
            return <LoadingSection />;
        } else {
            return (
                <OKModal
                    description={buildDescription}
                    footerType="navigation"
                    isOpen={displayDisclaimer}
                    onCloseCallback={this.handleCancel}
                    onPrimaryButtonClick={this.handleContinue}
                    onSecondaryButtonClick={this.handleCloseModal}
                    primaryButtonLoading={this.state.continueCalled}
                    primaryButtonText="brokerMiFIDUSPerson-continue"
                    secondaryButtonText="brokerMiFIDUSPerson-cancel"
                    title="brokerMiFIDUSPerson-important"
                />
            );
        }
    }
}

BrokerMIFIDUSPersonModal.propTypes = {
    displayWhileLoading: PropTypes.bool,
    onContinueOperation: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    isinId: PropTypes.string.isRequired,
    marketId: PropTypes.string,
    feeNumbers: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    eventCode: PropTypes.string,
    valueCode: PropTypes.string,
    history: PropTypes.object.isRequired,
    immBrokerMiFIDUSPerson: PropTypes.object.isRequired,
    onFetchInfo: PropTypes.func.isRequired,
    onBeforeContinueOperation: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    operationType: PropTypes.string,
};

module.exports = connect(
    (state) => ({
        immBrokerMiFIDUSPerson: state.brokerMiFIDUSPerson
    }),
    {
        onFetchInfo: BrokerMiFIDUSPersonActions.fetchInfo,
        onReset: BrokerMiFIDUSPersonActions.reset,
        onBeforeContinueOperation: BrokerMiFIDUSPersonActions.beforeContinueOperation
    }
)(withRouter(BrokerMIFIDUSPersonModal));
